/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Container, Row, Col, Card, Collapse, Button } from "react-bootstrap"
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import { useEffect, useState } from "react"
import DateInput from "../../../components/InputWrapper/DateInput"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "../../../globalStore/rootreducer"
import TextInput from "../../../components/InputWrapper/TextInput"
import SyabanRenrakuhyoGrid from "../SyabanRenrakuhyo/SyabanRenrakuhyoGrid"
import { Form } from "react-bootstrap"
import Spinner from "../../../components/Spinner"
import { SyabanRenrakuhyoProvider } from "../SyabanRenrakuhyo/SyabanRenrakuhyoContext"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import queryString from "query-string"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
  setInfoAlerts,
} from "../../../globalStore/alertStore"
import { 画面ロック解除 } from "../../../globalStore/progressStore"
import {
  TSyabanRenrakuhyoGetReq,
  TSyabanRenrakuhyoGetRes,
} from "../../../service/order/syabanRenrakuhyo/TSyabanRenrakuhyo"
import SyabanRenrakuhyoService from "../../../service/order/syabanRenrakuhyo/syabanRenrakuhyoService"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import BusyoService from "../../../service/master/busyo/busyoService"
import NinusiService from "../../../service/master/ninusi/ninusiService"
import dateUtil from "../../../ts/util/dateUtil"
import dayjs from "dayjs"
import NinusiSearchModal from "../../../components/SearchModal/NinusiSearchModal"
import * as wjcCore from "@grapecity/wijmo"

type T検索日区分ComboboxItem = {
  name: string
  value: string
}
export type T車番連絡表印刷GridItem = TSyabanRenrakuhyoGetRes

/**
 * 車番連絡表印刷
 * @returns
 */
const SyabanRenrakuhyo = () => {
  const history = useHistory()
  const location = useLocation()
  const dispatch: AppDispatch = useDispatch()

  const { LoginUserInfo: userInfo } = useSelector(
    (state: RootState) => state.user
  )
  const { yokueigyobiStr: 翌営業日 } = useSelector(
    (state: RootState) => state.date
  )

  const [accordionController, setAccordionController] = useState(true)

  //TODO:ページ名称確定必須
  let gridId = "SyabanRenrakuhyo_GridId"

  //#region [state]

  // 画面共通
  const [isSearching, setIsSearching] = useState(false)
  const [displaySearchCondition, setDisplaySearchCondition] =
    useState<TSyabanRenrakuhyoGetReq | null>()

  const [searchResult, setSearchResult] = useState<T車番連絡表印刷GridItem[]>()

  // 部所
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [部所コード, set部所コード] = useState<
    T部所マスタ["部所コード"] | null | undefined
  >(null)
  // 検索日
  const [検索日区分, set検索日区分] = useState<string | null | undefined>()
  const [検索日区分ItemSource, set検索日区分ItemSource] =
    useState<T検索日区分ComboboxItem[]>()

  const [検索日From, set検索日From] = useState<string | null | undefined>(
    翌営業日
  )
  const [検索日To, set検索日To] = useState<string | null | undefined>(翌営業日)

  //２列目
  const [荷主コード, set荷主コード] = useState<string | undefined>()
  const [荷主名, set荷主名] = useState<string | undefined>()

  // modal
  const [is荷主検索Modal, setIs荷主検索Modal] = useState(false)

  //#endregion

  //#region [comboboxState]
  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所isLoadEnded, set部所isLoadEnded] = useState<boolean>(false)

  // 検索日区分
  const [検索日区分ComboBox, set検索日区分ComboBox] = useState<TWijmoComboBox<
    T検索日区分ComboboxItem["value"],
    T検索日区分ComboboxItem
  > | null>(null)
  const [検索日区分IsLoadEnded, set検索日区分IsLoadEnded] =
    useState<boolean>(false)
  const [dataInitialized, setDataInitialized] = useState<boolean>(false)

  //#endregion

  //#region grid操作
  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)
  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  //#endregion

  //#region [effect]
  // 初期設定
  useEffect(() => {
    set部所コード(userInfo.部所コード)
    set検索日区分ItemSource(検索日区分データ)
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)
      setDataInitialized(true)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && dataInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        const restoreFunc = async () => {
          await inputNinusiCode(querySearchCondition.荷主コード)
          await search(querySearchCondition)
        }
        // 再検索

        restoreFunc().finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        set部所コード(userInfo.部所コード)
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, dataInitialized])

  //#endregion

  //#region [method]

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: Partial<TSyabanRenrakuhyoGetReq> = queryString.parse(
      location.search
    )
    // ユーザーの運行部所で初期表示
    set部所コード(query.受注部所コード ?? userInfo.部所コード ?? "")
    set検索日区分(query.検索日区分)
    set検索日From(query.検索日From)
    set検索日To(query.検索日To)
    set荷主コード(query.荷主コード)

    return query as TSyabanRenrakuhyoGetReq
  }

  /**
   * 検索
   */
  const search = async (searchCondition?: TSyabanRenrakuhyoGetReq) => {
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TSyabanRenrakuhyoGetReq | null | undefined
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    let msg: string[] = []

    const 検索開始日 = currentSearchCondition?.検索日From
      ? dateUtil.format(currentSearchCondition?.検索日From, "YYYY/MM/DD")
      : ""
    const 検索終了日 = currentSearchCondition?.検索日To
      ? dateUtil.format(検索日To, "YYYY/MM/DD")
      : ""

    if (検索開始日 > 検索終了日) {
      msg.push("・日付指定が「開始日付 ＞ 終了日付」となっています")
    }

    if (wjcCore.isNullOrWhiteSpace(currentSearchCondition?.荷主コード ?? "")) {
      msg.push("・荷主コードが未入力です")
    }

    if (msg.length > 0) {
      dispatch(setWarningAlerts(msg))
      return
    }
    setIsSearching(true)

    if (currentSearchCondition == null) return

    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new SyabanRenrakuhyoService().getList(
        currentSearchCondition
      )

      res.data.forEach((row: TSyabanRenrakuhyoGetRes) => {
        if (row.受注伝票番号 != null) {
          row.受注伝票番号 = row.受注伝票番号 + "-" + row.受注枝番
        }
      })
      setSearchResult([...res.data])

      if (res && res.data.length <= 0) {
        dispatch(setInfoAlerts(["検索条件に該当する受注データが存在しません"]))
        return
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * 検索条件作成
   * @param queryString
   */
  const createSearchCondition = (
    queryString?: string
  ): TSyabanRenrakuhyoGetReq | null | undefined => {
    return {
      受注部所コード: 部所コード,
      検索日区分: 検索日区分,
      検索日From: 検索日From,
      検索日To: 検索日To,
      荷主コード: 荷主コード,
    }
  }

  /**
   * 表示用検索条件作成
   * @param queryString
   */
  const createDisplaySearchCondition = (
    searchCondition: TSyabanRenrakuhyoGetReq
  ): TSyabanRenrakuhyoGetReq | null | undefined => {
    return {
      受注部所コード: searchCondition.受注部所コード,
      検索日区分: 検索日区分,
      検索日From: dayjs(searchCondition.検索日From).format("YYYY/MM/DD"),
      検索日To: dayjs(searchCondition.検索日To).format("YYYY/MM/DD"),
      荷主コード: searchCondition.荷主コード,
    }
  }

  // 荷主コード入力時の処理
  const inputNinusiCode = async (ninusiCode: string = "") => {
    let inner荷主Code = ninusiCode
    if (ninusiCode === "") {
      inner荷主Code = 荷主コード ? 荷主コード : ""
    }

    if (inner荷主Code === "") {
      set荷主名("")
      return
    }

    try {
      const 荷主res = await new NinusiService().getList({
        荷主コード: ninusiCode !== "" ? ninusiCode : undefined,
      })
      if (荷主res.data == null || 荷主res.data.length <= 0) {
        set荷主名("")
        return
      }

      const 荷主 = 荷主res.data[0]

      if (荷主 == null) {
        set荷主名("")
      } else {
        set荷主名(荷主.荷主名)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    }
  }

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">車番連絡表印刷</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-100rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body id="collapse-search-card-body">
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="w-15rem me-2">
                              <ComboBox.Busyo
                                placeholder="部所"
                                isLoadEnded={部所isLoadEnded}
                                setIsLoadEnded={set部所isLoadEnded}
                                isAllSelect={false}
                                isRequired={true}
                                listFilter={(item) => item.運行部所フラグ === 1}
                                itemsSource={部所ItemSource}
                                selectedValue={部所コード}
                                setSelectedValue={(v) => {
                                  set部所コード(v)
                                }}
                                ComboBox={部所ComboBox}
                                setComboBox={set部所ComboBox}></ComboBox.Busyo>
                            </div>
                            <div className="w-9rem">
                              <ComboBox.Default
                                placeholder="検索日区分"
                                itemsSource={検索日区分ItemSource}
                                isLoadEnded={検索日区分IsLoadEnded}
                                selectedValue={検索日区分}
                                isRequired={true}
                                setSelectedValue={(v) => {
                                  set検索日区分(v)
                                }}
                                setIsLoadEnded={set検索日区分IsLoadEnded}
                                ComboBox={検索日区分ComboBox}
                                setComboBox={
                                  set検索日区分ComboBox
                                }></ComboBox.Default>
                            </div>
                            <div className="w-10rem">
                              <DateInput
                                id="検索日From"
                                placeholder="検索日From"
                                isRequired={true}
                                value={検索日From}
                                defaultValue={翌営業日}
                                setValue={(v) => {
                                  set検索日From(v)
                                }}></DateInput>
                            </div>
                            <div style={{ width: "2rem", padding: "0.5rem" }}>
                              ～
                            </div>
                            <div className="w-10rem me-2">
                              <DateInput
                                id="検索日To"
                                placeholder="検索日To"
                                value={検索日To}
                                isRequired={true}
                                defaultValue={翌営業日}
                                setValue={(v) => {
                                  set検索日To(v)
                                }}></DateInput>
                            </div>
                            <div className="input-group">
                              <TextInput
                                style={{ width: "6rem" }}
                                id="荷主コード"
                                name="荷主コード"
                                value={荷主コード}
                                isRequired={true}
                                setValue={set荷主コード}
                                onBlur={() => inputNinusiCode()}
                                maxLength={5}
                                placeholder="荷主CD"
                              />
                              <button
                                type="button"
                                className="icon-button"
                                onClick={() => {
                                  setIs荷主検索Modal(true)
                                }}>
                                <FontAwesomeIcon
                                  className="icon-button-inner"
                                  icon={faSearch}
                                />
                              </button>
                              <TextInput
                                style={{ width: "25rem" }}
                                id="荷主名"
                                name="荷主名"
                                value={荷主名}
                                setValue={set荷主名}
                                isReadOnly={true}
                                maxLength={100}
                                placeholder="荷主名"
                              />
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            search()
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col xs={12}>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <SyabanRenrakuhyoProvider
                isSearching={{ state: isSearching, setState: setIsSearching }}
                isRestoreSearching={{
                  state: isRestoreSearching,
                  setState: setIsRestoreSearching,
                }}
                SearchResult={searchResult}
                searchDyType={{
                  state: 検索日区分,
                  setState: set検索日区分,
                }}
                searchDyFrom={{
                  state: 検索日From,
                  setState: set検索日From,
                }}
                searchDyTo={{
                  state: 検索日To,
                  setState: set検索日To,
                }}
                juchuBusyoCd={{
                  state: 部所コード,
                  setState: set部所コード,
                }}
                ninusiCd={{
                  state: 荷主コード,
                  setState: set荷主コード,
                }}
                gridInitialized={{
                  state: gridInitialized,
                  setState: setGridInitialized,
                }}>
                <SyabanRenrakuhyoGrid gridId={gridId}></SyabanRenrakuhyoGrid>
              </SyabanRenrakuhyoProvider>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {/* 荷主検索 */}
      <NinusiSearchModal
        size="lg"
        setIsShow={setIs荷主検索Modal}
        isShow={is荷主検索Modal}
        setNinusi={(荷主) => {
          set荷主コード(荷主.荷主コード)
          set荷主名(荷主.荷主名)
        }}></NinusiSearchModal>
    </Container>
  )
}

export default SyabanRenrakuhyo

// TODO:マスタ化するか要確認
const 検索日区分データ: T検索日区分ComboboxItem[] = [
  { name: "積日", value: "1" },
  { name: "卸日", value: "2" },
]
